/* unplugin-vue-components disabled */import { render } from "./QuizCheckableTextQuestion.vue?vue&type=template&id=2fa65892&scoped=true&ts=true"
import script from "./QuizCheckableTextQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizCheckableTextQuestion.vue?vue&type=script&lang=ts"

import "./QuizCheckableTextQuestion.vue?vue&type=style&index=0&id=2fa65892&scoped=true&lang=scss"
import "./QuizCheckableTextQuestion.vue?vue&type=style&index=1&id=2fa65892&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa65892"]])

export default __exports__